import http from '../api/api'
import config from '../api/constants'

const getAllBillers = async (data) => {
  try {
    const reqParams = {
      requestId: 'GETALLBILLERS',
      module:'PAYMENT',
      ...data,
    }
    const response = await http.post(config.apiRoute.GET_ALL_BILLERS, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getAllBillerBeneficiaries = async (data) => {
  try {
    const reqParams = {
      requestId: 'FETCHBILLERBENE',
      ...data,
    }
    const response = await http.post(config.apiRoute.GET_ALL_BILLER_BENEFICIARIES, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const addBillerBeneficiary = async (data) => {
  try {
    const reqParams = {
      requestId: 'ADDBILLERBENE',
      ...data,
    }
    const response = await http.post(config.apiRoute.ADD_BILLER_BENEFICIARY, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const getBillQuote = async (reqParams) => {
  try {
    const params = {
      ...reqParams,
      requestId: 'BILLPAYMENT',
      module: 'BILLPAYMENT',
    }
    const response = await http.post(config.apiRoute.GET_BILL_QUOTE, params)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}


const payBill = async (reqPrams) => {
  try {
    const params = {
      requestId: 'BILLPAYMENT',
      module: 'BP',
      ...reqPrams,
    }
    const response = await http.post(config.apiRoute.PAY_BILL, params)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const deleteBillerBene = async ({ beneId, serviceId }) => {
  try {
    const reqParams = {
      beneId,
      serviceId,
      requestId: 'DELETEBILLER',
    }
    const response = await http.post(config.apiRoute.GET_DELETE_BILLER_BENEFICIARIES, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

export function showFile(blob, fileName) {
  const newBlob = new Blob([blob], { type: 'application/pdf' })
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob)
    return
  }
  const data = window.URL.createObjectURL(newBlob)
  const link = document.createElement('a')
  link.href = data
  link.download = `${fileName}.pdf`
  link.click()
  setTimeout(() => {
    window.URL.revokeObjectURL(data)
  }, 100)
}


const getServiceById = async (data) => {
  try {
    const reqParams = {
      ...data,
      module: 'BILL',
      requestId: 'GETALLBILLERS',
    }
    const response = await http.post(config.apiRoute.getServiceById, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const getPendingBills = async (data) => {
  try {
    const reqParams = {
      ...data,
      module: 'BILL',
      requestId: 'GETALLBILLERS',
    }
    const response = await http.post(config.apiRoute.getPendingBills, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const viewScheduledPayments = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'SCHEDULEPAYMENT_VIEW',
      module: 'SCHEDULEDPAYMENTS',
    }
    const response = await http.post(config.apiRoute.VIEW_SCHEDULED_PAYMENT, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}
const verifyCancelScheduledPayments = async (reqParams) => {
  try {
    const params = {
      ...reqParams,
      requestId: 'SCHEDULEPAYMENT_CANCEL_VERIFY',
      module: 'SCHEDULEDPAYMENTS',
    }
    const response = await http.post(config.apiRoute.VERIFY_SCHDULED_PAYMENT, params)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}
const confirmCancelScheduledPayments = async (reqParams) => {
  try {
    const params = {
      ...reqParams,
      requestId: 'SCHEDULEPAYMENT_CANCEL_CONFIRM',
      module: 'SCHEDULEDPAYMENTS',
    }
    const response = await http.post(config.apiRoute.CONFIRM_SCHEDULED_PAYMENT, params)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const getAllBanks = async () => {
  try {
    const reqParams = {
      requestId: 'OTHERBANKSLIST',
    }
    const response = await http.post(config.apiRoute.GET_ALL_BANKS, reqParams)
    return response.data //.bankList
  } catch (err) {
    throw err.response.data
  }
}

const PaymentsService = {
  getAllBillers,
  getAllBillerBeneficiaries,
  addBillerBeneficiary,
  getBillQuote,
  payBill,
  deleteBillerBene,
  getServiceById,
  getPendingBills,
  viewScheduledPayments,
  verifyCancelScheduledPayments,
  confirmCancelScheduledPayments,
  getAllBanks
}
export default PaymentsService
